export default {
  name: 'marking--orderUpload',
  apiService: 'shoes',
  apiPath: '/admin/order/func/upload',
  urlParamName: 'marking--orderUpload',
};